import { render, staticRenderFns } from "./DetailTableFrame.vue?vue&type=template&id=f317781a&scoped=true"
import script from "./DetailTableFrame.vue?vue&type=script&lang=js"
export * from "./DetailTableFrame.vue?vue&type=script&lang=js"
import style0 from "./DetailTableFrame.vue?vue&type=style&index=0&id=f317781a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f317781a",
  null
  
)

export default component.exports